import gql from "graphql-tag";
import PropTypes from "prop-types";
import React from "react";
import { Col, Row } from "reactstrap";
import downloadContract from "../../api/contract";
import Alert from "../../utils/Alert";
import ItemDetails from "../common/ItemDetails";

export class ManagerInfo extends React.PureComponent {
  static propTypes = {
    storeName: PropTypes.string.isRequired,
    responsible: PropTypes.object.isRequired,
    uploadContract: PropTypes.func,
    contract: PropTypes.string,
  };

  static fragments = {
    responsibleDetails: gql`
      fragment ResponsibleDetails on Manager {
        id
        mobile
        email
        profile {
          lastName
          firstName
          birthdate
        }
      }
    `,
  };

  state = {
    contractName: null,
    loading: false,
  };

  onResponse = (cb = () => {}) => {
    // this.setState(
    //   {
    //     contractName: null
    //   },
    //   cb
    // );

    cb();
  };

  onChangeHandler = (e) => {
    const { responsible } = this.props;
    const file = e.target.files[0];
    if (file.type == "application/pdf") {
      this.setState(
        {
          contractName: file.name,
        },
        () => {
          this.props
            .uploadContract({
              variables: { contract: file, responsible: responsible.id },
            })
            .then(() => {
              this.onResponse(() => {
                Alert.success("Le contrat est déposé avec succès");
              });
            })
            .catch((error) => {
              this.onResponse(() => {
                if (error && error.graphQLErrors)
                  Alert.success(error.graphQLErrors[0].message);
              });
            });
        }
      );
    } else {
      e.target.files = [];
      Alert.error("Veuillez vérifier le type de contrat");
    }
  };

  downloadContract = () => {
    if (!this.state.loading) {
      this.setState(
        {
          loading: true,
        },
        () => {
          downloadContract(this.props.storeName)
            .then(() => {
              this.setState({
                loading: false,
              });
            })
            .catch(() => {
              this.setState({
                loading: false,
              });
            });
        }
      );
    }
  };

  render() {
    const {
      responsible: { mobile, email, profile },
      // contract
    } = this.props;
    // const { contractName } = this.state;

    // const uploadIcon =
    //   contract || contractName ? "fa fa-check" : "fa fa-upload";
    return (
      <React.Fragment>
        <div className="ml-4">
          <div className=" row col-6 mt-3">
            <h4 className="bold">Responsable</h4>
          </div>
          <Row>
            <Col sm={6} xs={12} className="NoPad2">
              <ItemDetails
                label="Nom du responsable"
                value={`${profile.firstName} ${profile.lastName}`}
                valueClassName="text-capitalize"
              />
            </Col>
            <Col sm={6} xs={12} className="NoPad2">
              <ItemDetails
                label="Téléphone"
                value={mobile}
                valueClassName="text-capitalize"
              />
            </Col>
          </Row>
          <Row className="DisBl">
            <Col className="NoPad2">
              <ItemDetails label="email" value={email} />
            </Col>
            <Col className="NoPad2">
              {/* <ItemDetails
                label="contrat"
                value={
                  <>
                    <div
                      onClick={this.downloadContract}
                      className="mb-2 mr-2  btn btn-secondary cursor-pointer text-white d-flex justify-content-between align-items-center BtnBox"
                    >
                      {this.state.loading && (
                        <i className="fa fa-spinner fa-spin" />
                      )}
                      TÉLÉCHARGER LE CONTRAT
                      <i className="fa fa-download ml-2" aria-hidden="true" />
                    </div>

                    <label
                      htmlFor="image"
                      className="mb-2 mr-2 btn btn-secondary cursor-pointer d-flex justify-content-between align-items-center BtnBox"
                    >
                      <Input
                        hidden
                        id="image"
                        name="image"
                        type="file"
                        accept="application/pdf"
                        onChange={this.onChangeHandler}
                      />
                      {contract || contractName
                        ? "CONTRAT DÉPOSÉ"
                        : "DÉPOSER LE CONTRAT"}
                      <i className={`${uploadIcon} ml-2`} aria-hidden="true" />
                    </label>
                    {contractName && (
                      <span className="text-primary text-bold">
                        {contractName}
                      </span>
                    )}
                  </>
                }
              /> */}
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}
const UPLOADCONTRACT = gql`
  mutation UploadContract($contract: Upload!, $responsible: ID!) {
    uploadContract(contract: $contract, responsible: $responsible) {
      id
    }
  }
`;
export default // graphql(UPLOADCONTRACT, {
//   name: "uploadContract"
// })
ManagerInfo;
